import React, { Suspense } from 'react';
import { Body } from './ui';

const NewPtAddress = () => {
  return (
    <Suspense>
      <Body />
    </Suspense>
  );
};

export default NewPtAddress;
